/**
 * @generated SignedSource<<a7351493ce9cbd3fcf0eb44a21739312>>
 * @relayHash 26f5586afcc341d386cda98562e2e244
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 96068d7a1113d99ae587c08d667afa086302750676fd838acb69bb886c235119

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type PageRestrictionsInput = {
  includeInvites?: boolean | null | undefined;
  read?: PageRestrictionInput | null | undefined;
  update?: PageRestrictionInput | null | undefined;
};
export type PageRestrictionInput = {
  group?: ReadonlyArray<PageGroupRestrictionInput> | null | undefined;
  user?: ReadonlyArray<PageUserRestrictionInput> | null | undefined;
};
export type PageGroupRestrictionInput = {
  id?: string | null | undefined;
  name: string;
};
export type PageUserRestrictionInput = {
  id: string;
};
export type useConvertPageToBlogMutation$variables = {
  cloudId: string;
  content?: string | null | undefined;
  contentId: string;
  destinationSpaceKey: string;
  message?: string | null | undefined;
  ncsStepVersion?: string | null | undefined;
  restrictions?: PageRestrictionsInput | null | undefined;
  schedulePublishDate?: string | null | undefined;
  sourceStatus: string;
  suppressNotifyWatchers?: boolean | null | undefined;
  syncRev?: string | null | undefined;
  title?: string | null | undefined;
  version?: number | null | undefined;
};
export type useConvertPageToBlogMutation$data = {
  readonly confluence_convertToBlogpost: {
    readonly content: {
      readonly id: string | null | undefined;
      readonly links: {
        readonly editui: string | null | undefined;
        readonly webui: string | null | undefined;
      } | null | undefined;
      readonly status: string | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useConvertPageToBlogMutation = {
  response: useConvertPageToBlogMutation$data;
  variables: useConvertPageToBlogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationSpaceKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ncsStepVersion"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restrictions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schedulePublishDate"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceStatus"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suppressNotifyWatchers"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "syncRev"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "version"
},
v13 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentBody",
            "variableName": "content"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "minorEdit",
            "variableName": "suppressNotifyWatchers"
          },
          {
            "kind": "Variable",
            "name": "ncsStepVersion",
            "variableName": "ncsStepVersion"
          },
          {
            "kind": "Variable",
            "name": "restrictions",
            "variableName": "restrictions"
          },
          {
            "kind": "Variable",
            "name": "schedulePublishDate",
            "variableName": "schedulePublishDate"
          },
          {
            "kind": "Variable",
            "name": "syncRev",
            "variableName": "syncRev"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
          },
          {
            "kind": "Variable",
            "name": "versionMessage",
            "variableName": "message"
          }
        ],
        "kind": "ObjectValue",
        "name": "confluenceContentInput"
      },
      {
        "kind": "Variable",
        "name": "destinationSpaceKey",
        "variableName": "destinationSpaceKey"
      },
      {
        "kind": "Variable",
        "name": "sourceStatus",
        "variableName": "sourceStatus"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "success"
},
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    },
    (v15/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        },
        {
          "kind": "ScalarField",
          "name": "editui"
        }
      ]
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "message"
},
v18 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useConvertPageToBlogMutation",
    "selections": [
      {
        "args": (v13/*: any*/),
        "concreteType": "ConfluenceConvertContentToBlogpostPayload",
        "kind": "LinkedField",
        "name": "confluence_convertToBlogpost",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "useConvertPageToBlogMutation",
    "selections": [
      {
        "args": (v13/*: any*/),
        "concreteType": "ConfluenceConvertContentToBlogpostPayload",
        "kind": "LinkedField",
        "name": "confluence_convertToBlogpost",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v18/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "26f5586afcc341d386cda98562e2e244",
    "id": "96068d7a1113d99ae587c08d667afa086302750676fd838acb69bb886c235119",
    "metadata": {},
    "name": "useConvertPageToBlogMutation",
    "operationKind": "mutation",
    "text": "mutation useConvertPageToBlogMutation($contentId:ID!,$content:String,$message:String,$suppressNotifyWatchers:Boolean,$syncRev:String,$ncsStepVersion:String,$title:String,$version:Int,$schedulePublishDate:String,$restrictions:PageRestrictionsInput,$cloudId:ID!,$destinationSpaceKey:String!,$sourceStatus:String!){confluence_convertToBlogpost(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,syncRev:$syncRev,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,schedulePublishDate:$schedulePublishDate,title:$title,version:$version,versionMessage:$message},destinationSpaceKey:$destinationSpaceKey,sourceStatus:$sourceStatus}){success,content{status,id,links{webui,editui}},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "c1ea39c835722794b607605c89d18ae4";

export default node;
